import { useEffect } from 'react';

export default function Untrack() {
    useEffect(() => {
        window.localStorage.setItem('plausible_ignore', 'true');
    });
    return (
        <div className='flex flex-col items-center justify-center h-screen'>
            <h1 className='text-4xl font-bold mb-4'>Untrack</h1>
            <p className='text-lg'>Deine Besuche werden nicht mehr getrackt.</p>
            <a href='/' className='mt-4 hover:underline'>Zurück zur Startseite</a>
        </div>
    );
}
